import { render, staticRenderFns } from "./SliderNavigationV2.vue?vue&type=template&id=03762ce7&scoped=true"
import script from "./SliderNavigationV2.vue?vue&type=script&lang=js"
export * from "./SliderNavigationV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03762ce7",
  null
  
)

export default component.exports